import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { PageTreeAfterIconProps } from './PageTreeAfterIcon.tsx';

export const PageTreeAfterIconLoader: LoadableType<PageTreeAfterIconProps> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-PageTreeAfterIcon" */ './PageTreeAfterIcon.tsx'))
			.PageTreeAfterIcon,
});
